import { type FC } from "react";
import { Salaries, type SalariesProps } from "@legacy_user_frontend/components/ui_parts/salaries";
import { WorkTimes, type WorkTimesProps } from "./src/work_times";
import * as styles from "./styles.css";

type RequirementsProps = {
  requirements: {
    salaries: SalariesProps["salaries"] | [];
    workTimes: WorkTimesProps["workTimes"] | [];
  };
  className?: string;
};

export const SalaryAndWorktimeRequirements: FC<RequirementsProps> = ({
  requirements: { salaries, workTimes },
  className,
}) => (
  <div className={`${styles.wrapper} ${className ?? ""}`}>
    <dl className={styles.table}>
      <dt className={`${styles.tableDt} ${styles.tableDtDdFlex}`}>
        <span>
          <i className="icon-yen" />
          <span className={styles.tableTitle}>給与</span>
        </span>
      </dt>
      <dd className={`${styles.tableDd} ${styles.tableDtDdFlex}`}>
        {salaries.length > 0 && <Salaries salaries={salaries} />}
      </dd>
      <dt className={`${styles.tableDt} ${styles.tableDtDdFlex} ${styles.tableDtNotFirst}`}>
        <span>
          <i className="icon-clock-1" />
          <span className={styles.tableTitle}>
            勤務
            <br />
            時間
          </span>
        </span>
      </dt>
      <dd className={`${styles.tableDd} ${styles.tableDtDdFlex} ${styles.tableDdNotFirst}`}>
        {workTimes.length > 0 && <WorkTimes workTimes={workTimes} />}
      </dd>
    </dl>
  </div>
);
